import { motion } from 'framer-motion';
import HeroSection from '../components/Home/HeroSection';
import AboutSection from '../components/Home/AboutSection';
import ServicesSection from '../components/Home/ServicesSection';
import SustainabilitySection from '../components/Home/SustainabilitySection';
import ContactSection from '../components/Home/ContactSection';

const Home = () => {
  return (
    <motion.div
      className="home-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <SustainabilitySection />
      <ContactSection />
    </motion.div>
  );
};

export default Home;
